package ir.yusefpasha.pages

import androidx.compose.runtime.*
import com.varabyte.kobweb.compose.foundation.layout.Arrangement
import com.varabyte.kobweb.compose.foundation.layout.Box
import com.varabyte.kobweb.compose.foundation.layout.Column
import com.varabyte.kobweb.compose.ui.Alignment
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.modifiers.fillMaxSize
import com.varabyte.kobweb.core.Page
import ir.yusefpasha.components.BackToTopButton
import ir.yusefpasha.components.OverFlowMenu
import ir.yusefpasha.sections.*

@Page
@Composable
fun HomePage() {

    var isExpandedMenu by remember { mutableStateOf(false) }

    Box(
        modifier = Modifier.fillMaxSize()
    ) {
        Column(
            modifier = Modifier.fillMaxSize(),
            verticalArrangement = Arrangement.Top,
            horizontalAlignment = Alignment.CenterHorizontally
        ) {
            MainSection { isExpandedMenu = isExpandedMenu.not() }
            AboutSection()
            ServiceSection()
            PortfolioSection()
            AchievementSection()
            TestimonialSection()
            ExperienceSection()
            ContactSection()
            FooterSection()
        }
        BackToTopButton()

        if (isExpandedMenu) {
            OverFlowMenu { isExpandedMenu = false }
        }
    }
}
